import initVueApp from "@/core.js";
const component = require("../views/Lookbook.vue").default;
initVueApp(component);
